<style lang="less">
    .updatePro{
        width: 800px;
        background-color: #fff;
        border: 1px solid #ccc;
        // margin: -20px auto;
        text-align: left;
        position: fixed;
        top: 50%;
        transform: translateY(-50%);
        left: 50%;
        z-index: 2;
        margin-left: -400px;
        border-radius: 8px;
        .up_title{
            padding: 10px 20px;
            color: #999;
        }
        .listBox{
            color: #333;
            padding: 10px 20px;
            >ul{
                >li{
                    display: flex;
                    align-items: baseline;
                    margin-bottom: 20px;
                    >span{
                        display: inline-block;
                        min-width: 80px;
                        text-align-last: justify;
                    }
                    >div{
                        margin-left: 20px;
                    }
                }
                .shopClass{
                    p{
                        margin-left: 20px;
                        color: #999;
                    }
                }
                .up_color{
                    >div{
                        >span{
                            color: #409EFF;
                            font-size: 14px;
                            cursor: pointer;
                        }
                        >ul{
                            display: flex;
                            flex-wrap: wrap;
                            margin-top: 10px;
                            max-height: 276px;
                            overflow-y: auto;
                            li{
                                cursor: pointer;
                                width: 50px;
                                // height: 80px;
                                margin-right: 20px;
                                img{
                                    width: 100%;
                                    height: 50px;
                                    border-radius: 4px;
                                }
                                p{
                                    text-align: center;
                                    font-size: 14px;
                                }
                                &.active{
                                    border: 1px solid #409EFF;
                                }
                            }
                        }
                    }
                }
            }
        }
        .footBtn{
            display: flex;
            justify-content:space-between;
            padding: 0 20px 20px;
        }
    }
    .up_meng{
        position: fixed;
        left: 0;
        top: 0;
        z-index: 3;
        width: 100%;
        height: 100%;
        background: rgba(51, 51, 51, 0.51);
    }
</style>
<template>
    <div>
        <div class="updatePro">
            <p class="up_title">添加板材</p>
            <div class="listBox">
                <ul>
                    <li class="shopClass">
                        <span>商城分类:</span>
                        <div>
                            <el-select v-model="updata.cloud_type" placeholder="请选择">
                                <el-option
                                v-for="item in brand_info"
                                :key="item"
                                :label="item"
                                :value="item">
                                </el-option>
                            </el-select>
                        </div>
                        <!-- <p>要添加分类请联系系统管理员</p> -->
                    </li>
                    <li>
                        <span>品牌:</span>
                        <div>
                            <el-select v-model="updata.brand_id" placeholder="请选择">
                                <el-option
                                v-for="item in brandList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                    </li>
                    <li class="up_color">
                        <span>颜色:</span>
                        <div>
                            <span @click="chooseColor">选择颜色></span>
                            <ul>
                                <!--  @click="chooseColor(item.id)" :class="updata.color.includes(item.id)?'active':''" -->
                                <li v-for="item in color" :key="item.id">
                                    <img :src="item.picture[0] +'?x-oss-process=image/resize,m_fill,h_50,w_50'" alt="">
                                    <p>{{item.name}}</p>
                                </li>
                            </ul>
                        </div>
                    </li>
                    <li>
                        <span>基材:</span>
                        <div>
                            <el-checkbox-group v-model="updata.substrate">
                                <el-checkbox :label="item" v-for="(item,index) in list.bspec" :key="index"></el-checkbox>
                            </el-checkbox-group>
                        </div>
                    </li>
                    <li>
                        <span>厚度:</span>
                        <div>
                            <el-checkbox-group v-model="updata.thick">
                                <el-checkbox :label="item" v-for="(item,index) in list.thick" :key="index"></el-checkbox>
                            </el-checkbox-group>
                        </div>
                        <!-- <p style="color:#999;marginLeft:20px;marginBottom:0;">需要更多厚度请联系系统管理员</p> -->
                    </li>
                    <!-- <li>
                        <span>钢板:</span>
                        <div>
                            <el-checkbox-group v-model="updata.steel_plate">
                                <el-checkbox :label="item" v-for="(item,index) in list.texture" :key="index"></el-checkbox>
                            </el-checkbox-group>
                        </div>
                    </li> -->
                    <li>
                        <span>规格:</span>
                        <div>
                            <el-checkbox-group v-model="updata.spec">
                                <el-checkbox :label="item" v-for="(item,index) in list.spec" :key="index"></el-checkbox>
                            </el-checkbox-group>
                        </div>
                    </li>
                    <li>
                        <span>贴面工艺:</span>
                        <div>
                            <el-checkbox-group v-model="updata.texture_method">
                                <el-checkbox :label="item" v-for="(item,index) in list.cratf" :key="index"></el-checkbox>
                            </el-checkbox-group>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="footBtn">
                <div>{{getCount?'您即将添加 '+ getCount + ' 种板材':''}}</div>
                <div>
                    <el-button @click="sureAdd">确定</el-button>
                    <el-button @click="cancel">取消</el-button>
                </div>
            </div>
        </div>
        <div class="up_meng" @click="chooseColor" v-if="boxShow"></div>
        <ColorBox v-show="boxShow" @chooseColor="chooseColor" :color_ids=[]></ColorBox>
    </div>
</template>
<script>
import ColorBox from './ChooseColorBox'
export default {
    components:{
        ColorBox
    },
    data(){
        return{
            boxShow:false,
            brandList:[],
            brand_info:[
                // {
                //     "type_name":"柜体板",
                //     "brand_data":[
                //         {
                //             "brand_id":1,
                //             "name":"daidai1"
                //         },
                //         {
                //             "brand_id":2,
                //             "name":"daidai2"
                //         }
                //     ]
                // },
                // {
                //     "type_name":"密度板",
                //     "brand_data":[
                //         {
                //             "brand_id":1,
                //             "name":"ceshi1"
                //         },
                //         {
                //             "brand_id":2,
                //             "name":"ceshi2"
                //         }
                //     ]
                // },
            ],
            color:[],
            list:{
                bspec:[

                ],
                thick:[

                ],
                texture:[

                ],
                spec:[

                ],
                craft:[

                ]
            },
            updata:{
                cloud_type:'',
                brand_id:'',
                color:[],
                substrate:[],
                thick:[],
                spec:[],
                // steel_plate:[],
                texture_method:[]
            },
        }
    },
    methods:{
        chooseColor(colorList){
            console.log('???',colorList)
            this.boxShow = !this.boxShow
            if(Array.isArray(colorList)){
                this.color = colorList
                console.log('////',this.color)
                this.updata.color = []
                colorList.forEach(item => {
                    this.updata.color.push(item.id)
                })
            }
        },
        // changeClass(value){
        //     this.updata.brand = ''
        //     this.brand_info.forEach(item => {
        //         if(item.type_name == value){
        //             this.brandList = item.brand_data
        //         }
        //     })
        // },
        sureAdd(){
            let data = this.updata
            if(data.cloud_type == ''){
                this.$message.warning('请选择分类')
                return
            }
            if(data.brand == ''){
                this.$message.warning('请选择品牌')
                return
            }
            if(data.color.length == 0){
                this.$message.warning('请选择颜色')
                return
            }
            if(data.substrate.length == 0){
                this.$message.warning('请选择基材')
                return
            }
            if(data.thick.length == 0){
                this.$message.warning('请选择厚度')
                return
            }
            if(data.spec.length == 0){
                this.$message.warning('请选择规格')
                return
            }
           /*  if(data.steel_plate.length == 0){
                this.$message.warning('请选择钢材')
                return
            } */
            if(data.texture_method.length == 0){
                this.$message.warning('请选择贴面工艺')
                return
            }

            
            // delete data.color
            // this.axios.post('https://ggtools.thinkerx.com/erp/supplier_save_commodity',{
            //     data,
            //     uid:this.userInfo.id,
            //     supplier_id:this.supplier_id,
            // }).then(res => {
            //     if(res.data.status == 1){
            //         this.$message.success('添加成功')
            //         this.$emit('addProduct',false)
            //     }else{
            //         this.$message('添加失败')
            //     }
            // })
            this.$post("/py/erp/supplier_save_commodity",{
                data,
                uid:this.userInfo.id,
                supplier_id:this.supplier_id,
            },res => {
                 if(res.status == 1){
                    this.$message.success('添加成功')
                    this.$emit('addProduct',false)
                }else{
                    this.$message('添加失败')
                }
            })
        },
        cancel(){
            this.$emit('addProduct',false)
        },
    },
    computed: {
        supplierInfo(){
            return this.$store.state.supplierInfo
        },
        supplier_id(){
          if(this.$store.state.supplierInfo){
            return this.$store.state.supplierInfo.id
          }else{
            return 0
          }
        },
        userInfo(){
            return this.$store.state.userInfo
        },
        getCount(){
            let updata = this.updata
            if(updata.cloud_type&&updata.brand_id&&updata.color.length&&updata.substrate.length&&updata.thick.length&&updata.spec.length/* &&updata.steel_plate.length */&&updata.texture_method.length){
                return updata.color.length*updata.substrate.length*updata.thick.length*updata.spec.length*updata.spec.length*updata.texture_method.length
            }else{
                return 0
            }

        }
    },
    mounted(){
        // 获取分类
        // this.axios.post('https://ggtools.thinkerx.com/erp/get_cloud_user_setting',{
        //     uid:this.userInfo.id,
        //     supplier_id:this.supplier_id,
        // }).then(res => {
        //     this.brand_info = res.data.data.plank_part_type_setting
        // })
        this.$post("/py/erp/get_cloud_user_setting",{
            uid:this.userInfo.id,
            supplier_id:this.supplier_id,
        },res => {
            console.log('获取分类',res)
            this.brand_info = res.data.plank_part_type_setting
        })
        // 获取品牌
        // this.axios.get('https://ggtools.thinkerx.com/erp/search_brand_list',{
        //     params:{
        //         uid:this.userInfo.id,
        //         supplier_id:this.supplier_id,
        //         project:'板材'
        //     }
        // }).then(res => {
        //     let list = res.data.data.brand_data
        //     if(list && list.length){
        //         this.brandList = res.data.data.brand_data
        //     }else{
        //         this.$message.warning('暂无品牌，请先在基础数据中设置品牌')
        //     }

        // })
        this.$get("/py/erp/search_brand_list",{
            uid:this.userInfo.id,
            supplier_id:this.supplier_id,
            project:'板材'
        },res => {  
            let list = res.data.brand_data
            if(list && list.length){
                this.brandList = res.data.brand_data
            }else{
                this.$message.warning('暂无品牌，请先在基础数据中设置品牌')
            }
        })
        // this.axios.get('https://ggtools.thinkerx.com/erp/get_supplier_setting',{
        //     params:{
        //         uid:this.userInfo.id,
        //         supplier_id:this.supplier_id,
        //         setting_type:'plank_setting'
        //     }
        // }).then(res => {
        //     this.list = res.data.data
        // })
        this.$get("/py/erp/get_supplier_setting",{
            uid:this.userInfo.id,
            supplier_id:this.supplier_id,
            setting_type:'plank_setting'
        },res => {  
            this.list = res.data
        })
    }
}
</script>
